export class ArticleMedia {
  constructor (elem) {
    this.embed = elem.querySelector('[data-article-media-embed]')
    this.toggle = elem.querySelector('[data-article-media-play]')

    if (this.toggle === null) {
      return
    }

    this.toggle.addEventListener('click', (e) => {
      this.play()
    })
  }

  play () {
    this.embed.classList.add('a-media__video--play')
  }
}

export function setupArticleMedias (document) {
  const elems = document.querySelectorAll('[data-article-media]')
  const articleMedias = []

  for (const element of elems) {
    articleMedias.push(new ArticleMedia(element))
  }

  return articleMedias
}
